import React, { useState, useEffect } from 'react'
import { Table, Image, OverlayTrigger, FormControl, Button, Label, Dropdown, Collapse, Tooltip, Form, Row, Col } from 'react-bootstrap'
import '../../index.css'

import {
    FetchInventory, FetchLocalizedAnalysis, FetchArticleTypeImages, FetchStocksReport, FetchRegisterStocksReport,
    FetchDesigners, FetchDeleteTransactionDraft, FetchCreatePartialInventoryTransactionDraft, FetchUpdateTransactionDraft
} from '../../fetcher'
import { SimpleDateSelect } from '../presentational-components/FilterComponents'

//import { getTotal, getSizeNumbers, getStringsSizeEntries } from '../presentational-components/TableComponent'
import AlertMessage from '../presentational-components/AlertMessage'
import { ModalComponent } from '../presentational-components/ModalComponent'
import { RenderImage } from '../presentational-components/ImageViewer'
import DeliveryOrderContainer from './DeliveryOrderContainer'
import MaintainStock from './MaintainStock'
import TransactionView from './TransactionView'
import { CustomToggle } from '../presentational-components/simple-objects/CustomDropDown'
import { ExportCSV } from '../presentational-components/ExportCSV'
import moment from 'moment'
import 'moment/locale/de'
import LoadingSpinner from '../presentational-components/LoadingSpinner'
import { useSortSalesReport } from '../presentational-components/tablehooks'
import { useFilterReport } from '../presentational-components/filterutils'
import { parseFloatCurrency } from '../presentational-components/floatnumberparsing'





import { useExpandRows, useSortTransactions } from '../presentational-components/tablehooks'
import EnumValueTranslations from '../presentational-components/EnumValueTranslations';
import DescriptionTooltip from '../presentational-components/DescriptionTooltip'
import { getSizeEntries, getSizeNumbers, getCorrectionNumbers, getTotal } from '../presentational-components/TableComponent'
import DraftTemplate from './DraftTemplate'




moment.locale('de')


const InventoryPartTransactionsView = ({ inventoryCreationSuccessfull, inventoryTransaction, createStartFullInventory, updateStartedFullInventory, createInventory, reloadParent, setTaskName1 }) => {
    const controller = new AbortController()
    const signal = controller.signal
    console.log("InventoryPartTransactionsView5")

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const { expandRow, getIsExpandedRow } = useExpandRows()
    const [draftToUpdate, setDraftToUpdate] = useState()
    const [showDeliveryDraftMask, setShowDeliveryDraftMask] = useState(false)
    const [selectedDesigner, setSelectedDesigner] = useState(null)


    const [alertMessage, setAlertMessage] = useState("")
    const [showInventoryTransactionMask, setShowInventoryTransactionMask] = useState(false)
    const [transactionNumber, setTransactionNumber] = useState(inventoryTransaction != null ? inventoryTransaction.TransactionNumber : "")
    const [remark, setRemark] = useState(inventoryTransaction != null ? inventoryTransaction.Remark : "")
    const [transactionDate, setTransactionDate] = useState(inventoryTransaction != null ? moment(inventoryTransaction.DateOfTransaction).format("DD.MM.YYYY") : moment(Date.now()).format("DD.MM.YYYY"))
    const [releaseButtonClicked, setReleaseButtonClicked] = useState(false)

    const handleDatePickerCallback = (date) => {
        setTransactionDate(prev => prev = moment(date).format("DD.MM.YYYY"))
    }

    const handleClearFilter = () => { }

    const handleShowInventoryTransactionMask = () => {
        setShowInventoryTransactionMask(true)
    }
    const handleCloseInventoryTransactionMask = () => {
        setShowInventoryTransactionMask(false)
    }
    const designerHeaderDefault = "Designer auswählen"
    const [designerNameHeader, setDesignerHeader] = useState(designerHeaderDefault)
    const [designerFilterInput, setDesignerFilterInput] = useState("")
    const [taskName, setTaskName] = useState("Unbekannte Inventur-Aufgabe")
    const handleDesignerFilter = (e) => {
        setDesignerFilterInput(e.target.value)
    }
    const [designerSelection, setDesignerSelection] = useState(Object.keys(inventoryTransaction).includes("Designers") && inventoryTransaction.Designers.length > 0 ? inventoryTransaction.Designers[0] : null)

    const handleSetDesignerSelection = (designer) => {
        setDesignerSelection(designer)
        setDesignerHeader(designer.DesignerName)
        console.log("single-designer-select", document.getElementById("single-designer-select"))
    }

    useEffect(() => {
        console.log("InventoryPartTransactionsView2", Date.now(), inventoryTransaction, designerSelection, transactionDate, remark, transactionNumber)
        setDesignerSelection(Object.keys(inventoryTransaction).includes("Designers") && inventoryTransaction.Designers.length > 0 ? inventoryTransaction.Designers[0] : null)
        setTransactionDate(inventoryTransaction != null ? moment(inventoryTransaction.DateOfTransaction).format("DD.MM.YYYY") : moment(Date.now()).format("DD.MM.YYYY"))
        setRemark(inventoryTransaction != null ? inventoryTransaction.Remark : "")
        setTransactionNumber(inventoryTransaction != null ? inventoryTransaction.TransactionNumber : "")
        console.log("InventoryPartTransactionsView22", Date.now(), inventoryTransaction, designerSelection, transactionDate, remark, transactionNumber)
    }, []);


    const reload = () => {
        reloadParent()
    }

    const removeTransactionDraft = (e, sysId) => {
        e.preventDefault()
        setTaskName("Die ausgewählte Entwürfe werden gelöscht")
        FetchDeleteTransactionDraft(sysId, openAlert, reload, "OutgoingTransactions")
    }

    const updateTransactionDraft = (e, transactionDraft) => {
        e.preventDefault()
        console.log("updateTransactionDraft")
        console.log(transactionDraft)
        setDraftToUpdate(transactionDraft)
        setShowDeliveryDraftMask(true)
    }

    const getColourClassStatus = (status) => {
        //if (status == "InTransit") return "inTransit"
        if (status == "Confirmed") return "approved"
        else if (status == "Inaccurate") return "correction"
        else return "inTransit"
    }

    const getNewOrExistingTransactionHeader = (transaction) => {
        console.log("getNewOrExistingTransactionHeader", transaction)
        if (transaction !== null && transaction !== undefined)
            return "Bestehende Inventur bearbeiten";
        else
            return "Neue Inventur anlegen";
    }

    const getTotalTotal = (articleTypes) => {
        let numbersTotal = 0
        articleTypes.forEach(x => {
            let numbers = x.Sizes.map(entry => parseInt(entry.Amount))
            let total = 0
            numbers.map(number => total = parseInt(total) + parseInt(number))

            numbersTotal += total
        })

        return numbersTotal
    }

    const createEmptyPartialTransaction = (e, designer) => {
        e.preventDefault();
        setTaskName("Es wird leere Inventur für " + designer.DesignerName + " erstellt.")
        document.getElementById(designer.DesignerSysId).hidden = true
        console.log("createEmptyTransaction designer", designer, designer.DesignerSysId)

        let draftToSave = {
            FullInventoryTransactionSysId: inventoryTransaction.AbstractTransactionSysId,
            DesignerSysId: designer.DesignerSysId,
            TransactionType : "",
            SerializedArticleData : "[]",
            IsFAEXDelivery : false,
            BoutiqueSysId : "",
            Remark : "",
            CreateTransactionFromDraft : false,
            ToLowerStock : false,
            TransactionNumber: "",
            TransactionDate: moment(Date.now()).format("DD.MM.YYYY").toString()
        }

        function f(e) { }
        console.log("createEmptyTransaction", draftToSave, designer)
        FetchCreatePartialInventoryTransactionDraft(draftToSave, f, openAlert, reloadParent, f, f, signal, "createEmptyPartialTransaction" + designer.DesignerSysId)
    }

    const startNewPartialInventory = (e, designer) => {
        e.preventDefault();
        setSelectedDesigner(prev => prev = designer)
        console.log("selectedDesigner", selectedDesigner, designer)
        handleShowInventoryTransactionMask()
    }

    const createStartFullInventoryLocal = (e) => {
        e.preventDefault();

        let startFullInventoryTransaction = {
            Remark: remark,
            TransactionNumber: transactionNumber,
            TransactionDate: transactionDate
        }
        createStartFullInventory(startFullInventoryTransaction)
    }

    const updateStartedFullInventoryLocal = (e) => {
        e.preventDefault();
        let startedFullInventoryTransactionUpdate = {
            Remark: remark,
            TransactionNumber: transactionNumber,
            TransactionDate: transactionDate,
            AbstractTransactionSysId: inventoryTransaction.AbstractTransactionSysId,
            SerializedArticleData: "[]",
            TransactionType: "FullInventoryDraft"
        }
        console.log("startedFullInventoryTransactionUpdate", startedFullInventoryTransactionUpdate)
        updateStartedFullInventory(startedFullInventoryTransactionUpdate)
    }

    const releaseInventory = (e, sysId) => {
        e.preventDefault()
        document.getElementsByClassName("to-be-hidden1")[0].hidden = true
        document.getElementsByClassName("to-be-hidden2")[0].hidden = true
        setTaskName1("Die neue Inventur wird gespeichert")
        setReleaseButtonClicked(true)
        createInventory(sysId, "InventoryMain")
    }

    const messageForConditionToReleaseInventory = () => {
        if (!Object.keys(inventoryTransaction).includes("Designers"))
            return "Neue Inventur muss zuerst gestartet werden"
        else if (inventoryTransaction.Designers.length == 0)
            return "Es muss mind. ein Designer bestehen"
        else if (inventoryTransaction.Designers.some(x => x.PartialInventoryTransactionForDesigner == undefined || x.PartialInventoryTransactionForDesigner == null))
            return "Es muss noch " + inventoryTransaction.Designers.filter(x => x.PartialInventoryTransactionForDesigner == undefined || x.PartialInventoryTransactionForDesigner == null).length + " partielle Inventuren eingegeben werden"
        else
            return ""

    }

    const InventoryForParticularDesignerView = (designer) => {
        //console.log("InventoryForParticularDesignerView1", designer, inventoryTransaction.Designers, inventoryTransaction.Designers.find(x => x.DesignerSysId == designerSelection.DesignerSysId))
        return (
            designer.PartialInventoryTransactionForDesigner ?
            <>
            <div>

                <h4>Inventur für {designer.DesignerName}. Der Inventur-Entwurf beinhaltet insgesamt {getTotalTotal(designer.PartialInventoryTransactionForDesigner.Articles)} Artikel</h4>
                <Table className="table-sm table-striped-immediate">
                    <thead className="sticky-table-header">
                        <th></th>
                        <th className="mainColumn">Erstellungsdatum
                        </th>
                        <th className="mainColumn">Lieferscheinnr.
                        </th>
                        <th className="mainColumn">Lieferdatum
                        </th>
                        <th className="mainColumn">Art
                        </th>
                        <th className="mainColumn">Status
                        </th>
                        <th className="mainColumn">Bemerkung
                        </th>
                        <th></th>
                        <th></th>
                    </thead>
                    <tbody>
                        {[designer.PartialInventoryTransactionForDesigner].map((transaction) =>
                            <>
                                <tr key={designer.DesignerSysId} className="salesboutique-mainrow" onClick={(e) => { console.log("expandRow main row ", e.target, e.target.value, e.eventPhase); expandRow(e, transaction.TransactionSysId) }} aria-expanded={getIsExpandedRow(transaction.TransactionSysId)} aria-controls={transaction.TransactionSysId}>
                                    {getIsExpandedRow(transaction.TransactionSysId) ? <td className="expandIndicator">&#8722;</td> : <td className="expandIndicator">&#43;</td>}
                                    <td>{transaction.CreationDate}</td>
                                    <td>{transaction.TransactionNumber}</td>
                                    <td>{transaction.TransactionDate}</td>
                                    <td>{EnumValueTranslations(transaction.Type)}</td>
                                    <td className={getColourClassStatus(transaction.State)}>{EnumValueTranslations(transaction.State)}</td>
                                    <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltip(transaction.Remark)}>
                                        <td className="remark-td">{transaction.Remark}</td>
                                    </OverlayTrigger>
                                    <td></td>
                                    {transaction.IsDraft &&
                                        <td>
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip> Lieferschein bearbeiten </Tooltip>}>
                                                <Button className="button-mar" size="sm" variant="secondary" onClick={(e) => { console.log("UpdateDraft main row ", e.target, e.target.value, e.eventPhase); updateTransactionDraft(e, transaction); startNewPartialInventory(e, designer); e.stopPropagation() }}>&#9998;</Button>
                                            </OverlayTrigger>
                                            <OverlayTrigger className="remove-order-td" placement="bottom" overlay={<Tooltip> Lieferschein löschen </Tooltip>}>
                                                <a className="remove-order" href="" onClick={(e) => removeTransactionDraft(e, transaction.TransactionSysId)} variant="secondary">&#10060;</a>
                                            </OverlayTrigger>
                                        </td>
                                    }
                                </tr>


                                <Collapse in={getIsExpandedRow(transaction.TransactionSysId)} timeout={30}>
                                    <td colSpan="6" className="td-nomargin">
                                        <div id={transaction.TransactionSysId} className="salesBoutique-child-div">
                                            {[...new Set(transaction.Articles.map(article => article.SizeCat))].map(sizeCat =>
                                                <>
                                                    <thead className="sticky-table-header">
                                                        <tr>
                                                            <th className="imageColumn"></th>
                                                            <th>Designername</th>
                                                            <th>Artikelnr. FAEX</th>
                                                            <th>Artikelnr. Designer</th>
                                                            <th>{sizeCat}</th>
                                                            <th>Farbe</th>
                                                            <th>Vk-Preis</th>
                                                            {getSizeEntries(transaction.Articles.find(x => x.SizeCat === sizeCat).Sizes)}
                                                            <th className="sizeColumn">Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {transaction.Articles.sort((a, b) => a.DesignerName.localeCompare(b.DesignerName) || a.Name.localeCompare(b.Name))
                                                            .filter(x => x.SizeCat === sizeCat).map(article =>
                                                                <>
                                                                    <tr>
                                                                        <td className="imageColumn">{RenderImage(article.Image)}</td>
                                                                        <td>{article.DesignerName}</td>
                                                                        <td>{article.ArticleIdFaex}</td>
                                                                        <td>{article.ArticleNumberDesigner}</td>
                                                                        <td>{article.Name}</td>
                                                                        <td>{article.Colour}</td>
                                                                        <td className="numberColumn">{parseFloat(article.SalePrice).toFixed(2).replace('.', ',') + "€"}</td>
                                                                        {getSizeNumbers(article.Sizes)}
                                                                        {getTotal(article.Sizes)}

                                                                        {/*{transaction.State == "InProcess" ?*/}
                                                                        {/*    <td>*/}
                                                                        {/*        <OverlayTrigger placement="bottom" overlay={<Tooltip> Korrektur anlegen </Tooltip>}>*/}
                                                                        {/*            <Button className="button-mar" size="sm" variant="secondary" onClick={() => openCorrectionLine(transaction.TransactionSysId, article.ArticleTypeSysId)}>&#9998;</Button>*/}
                                                                        {/*        </OverlayTrigger>*/}
                                                                        {/*    </td>*/}
                                                                        {/*    : null}*/}
                                                                    </tr>
                                                                </>
                                                            )}

                                                        <tr className="stockReport-row">
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>Summe: </td>
                                                            <td>{getTotalTotal(transaction.Articles)}</td>
                                                        </tr>

                                                    </tbody>
                                                </>
                                            )}
                                        </div>

                                        {/*{transaction.StateCorrected == "_corrected" ?*/}
                                        {/*    <tr>*/}
                                        {/*        <td></td>*/}
                                        {/*        <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State, true)}>Korrektur abschicken</Button></td>*/}
                                        {/*    </tr>*/}
                                        {/*    : null}*/}

                                        {/*{(transaction.StateCorrected == "" || transaction.StateCorrected == undefined) && transaction.State == "InProcess" ?*/}
                                        {/*    <tr>*/}
                                        {/*        <td></td>*/}
                                        {/*        <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State)}>Lieferung bestätigen &#10003;</Button></td>*/}
                                        {/*    </tr>*/}
                                        {/*    : null}*/}

                                        {/*{(transaction.StateCorrected == "" || transaction.StateCorrected == undefined) && transaction.State == "InTransit" ?*/}
                                        {/*    <tr>*/}
                                        {/*        <td></td>*/}
                                        {/*        <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State)}>Liefereingang bestätigen &#10003;</Button></td>*/}
                                        {/*    </tr>*/}
                                        {/*    : null}*/}

                                        {/*{(transaction.StateCorrected == "" || transaction.StateCorrected == undefined) && transaction.State == "Arrived" ?*/}
                                        {/*    <tr>*/}
                                        {/*        <td></td>*/}
                                        {/*        <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State)}>Bearbeitung bestätigen &#10003;</Button></td>*/}
                                        {/*    </tr>*/}
                                        {/*    : null}*/}

                                        {/*<tr>*/}
                                        {/*    <td></td>*/}
                                        {/*    <td><ExportCSV className="searchBar" disabled={false} csvData={getCsvData(transaction.Articles, [...new Set(transaction.Articles.map(article => article.SizeCat))])} fileName={getCsvFileName(transaction.TransactionSysId, transaction.CreationDate, transaction.SourceOrTargetName)} isTransaction={true} /></td>*/}
                                        {/*</tr>*/}

                                    </td>
                                </Collapse>
                            </>
                        )}
                    </tbody>
                </Table>
            </div>
            <ModalComponent handleShow={showInventoryTransactionMask && selectedDesigner == designer} handleClose={handleCloseInventoryTransactionMask}
                reload={reload} modalTitle="Inventur-Entwurf zu bearbeiten"
                modalBody={<DraftTemplate handleCloseMask={handleCloseInventoryTransactionMask} transactionType={"PartInventoryDraft"} draft={designer.PartialInventoryTransactionForDesigner} reloadParent={reload} selectedDesigner={selectedDesigner != null ? { DesignerName: selectedDesigner.DesignerName, MandatorSysId: selectedDesigner.DesignerSysId } : null} transactionDateExternal={inventoryTransaction.DateOfTransaction} dateFixed={true} draftCreateOrUpdateSettings={{ isDraftUpdate: true, FetchUpdateTransactionDraft: FetchUpdateTransactionDraft, FetchCreateTransactionDraft: FetchCreatePartialInventoryTransactionDraft }} OtherProperties={{ FullInventoryTransactionSysId: inventoryTransaction.AbstractTransactionSysId, DesignerSysId: designer.DesignerSysId }} isDraftUpdate={false} />} tabletView={true} />
        </>                    
        :
        <>
            <div>
                <h4>Inventur für {designer.DesignerName} wurde noch nicht angelegt</h4>
                        <div className="inline" id={designer.DesignerSysId}>
                    <Button variant="secondary" className="new-transaction-btn" onClick={(e) => startNewPartialInventory(e, designer)}>{getNewOrExistingTransactionHeader(designer.PartialInventoryTransactionForDesigner)}</Button>
                    <Form.Label className="new-transaction-btn">&nbsp; oder &nbsp;</Form.Label>
                    <Button variant="secondary" className="new-transaction-btn" onClick={(e) => createEmptyPartialTransaction(e, designer)}>Leere Inventur erzeugen</Button>
                        </div>
                <ModalComponent handleShow={showInventoryTransactionMask && selectedDesigner == designer} handleClose={handleCloseInventoryTransactionMask}
                    reload={reload} modalTitle="Neuer Inventur-Entwurf"
                            modalBody={<DraftTemplate handleCloseMask={handleCloseInventoryTransactionMask} transactionType={"PartInventoryDraft"} reloadParent={reload} selectedDesigner={selectedDesigner != null ? { DesignerName: selectedDesigner.DesignerName, MandatorSysId: selectedDesigner.DesignerSysId } : null} transactionDateExternal={inventoryTransaction.DateOfTransaction} dateFixed={true} draftCreateOrUpdateSettings={{ isDraftUpdate: false, FetchUpdateTransactionDraft: FetchUpdateTransactionDraft, FetchCreateTransactionDraft: FetchCreatePartialInventoryTransactionDraft }} OtherProperties={{ FullInventoryTransactionSysId: inventoryTransaction.AbstractTransactionSysId, DesignerSysId: designer.DesignerSysId }} />} tabletView={true} />
                <LoadingSpinner task={taskName} area={"createEmptyPartialTransaction" + designer.DesignerSysId} />
            </div>
        </>)
    }

    return (
        <>
            <div className="tablet-transactions">
                <Form>
                    <Row>
                        <Col colSpan={3}>
                            <Form.Label className="form remark tablet-center inventory-form-headline">{inventoryCreationSuccessfull == true ? "Die Inventur wurde erfolgreich gespeichert" : Object.keys(inventoryTransaction).includes("Designers") ? "Die Eingabe zur Inventur wurde gestartet." : "Es wurde keine aktuelle Inventur Transaktion gefunden."}</Form.Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col colSpan={3}>
                            <LoadingSpinner className="form remark tablet-center" task={taskName} area={"InventoryMain"} />
                        </Col>
                    </Row>
                    <Row hidden={releaseButtonClicked}>
                        <Col>
                            <Form.Group as={Row}>
                                <Form.Label className="inventory-form-label">Entwurfsnummer &nbsp;&nbsp;</Form.Label>
                                <Form.Control className="smallInput" size="sm" placeholder="Entwurfscheinnummer" onChange={(e) => setTransactionNumber(e.target.value)} value={transactionNumber} />
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Form.Label className="inventory-form-label">Datum der Inventur &nbsp;&nbsp;</Form.Label>
                                {SimpleDateSelect(handleDatePickerCallback, handleClearFilter, transactionDate)}
                            </Form.Group>
                            <Form.Group as={Row}>
                                {Object.keys(inventoryTransaction).includes("DateOfLastInventory") && inventoryTransaction.DateOfLastInventory != null ? "Die letzte Inventur fand am " + moment(inventoryTransaction.DateOfLastInventory).format("DD.MM.YYYY") + " statt." : "Es wurde noch keine Inventur durchgeführt."}
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label className="inventory-form-label">Bemerkung</Form.Label>
                                <Form.Control className="order-textarea" as="textarea" rows={8} onChange={(e) => setRemark(e.target.value)} value={remark} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row hidden={releaseButtonClicked}>
                        <Button className="tablet-center" variant="secondary" onClick={(e) => Object.keys(inventoryTransaction).includes("Designers") ? updateStartedFullInventoryLocal(e) : createStartFullInventoryLocal(e)}>{Object.keys(inventoryTransaction).includes("Designers") ? "Die Grunddaten von gestarteten Inventur speichern" : "Neue Inventur starten"}</Button>
                        <div>&nbsp;&nbsp;</div>
                        <Button className="tablet-center" variant="secondary" onClick={(e) => releaseInventory(e, inventoryTransaction.AbstractTransactionSysId)} disabled={messageForConditionToReleaseInventory() != "" || releaseButtonClicked}>Inventur veranlassen</Button>
                        <Form.Label className="new-transaction-btn validation-error">&nbsp;&nbsp; {messageForConditionToReleaseInventory()}</Form.Label>
                    </Row>
                </Form>
            </div>
            <div className="to-be-hidden1">
                {Object.keys(inventoryTransaction).includes("Designers") ?

                    <div className="tablet-transactions article-dropdown">
                        <Form>
                            <div className="tablet-center inventory-form-headline">Einzelne Inventuren verarbeiten</div>
                            <Dropdown className="form">
                                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components-boutique">
                                    {designerNameHeader}
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="article-dropdown" id="single-designer-select">
                                    <FormControl className="globalSearch-deliveryOrder" as="input" placeholder="Name Designer..." value={designerFilterInput} onChange={handleDesignerFilter}></FormControl>
                                    {
                                        inventoryTransaction.Designers.filter(x => x.DesignerName.toLowerCase().includes(designerFilterInput.toLowerCase()))
                                            .sort((a, b) => a.DesignerName.localeCompare(b.DesignerName))
                                            .map(designer =>
                                                <Dropdown.Item variant="secondary" className="listGroup-item" active={false} onSelect={() => handleSetDesignerSelection(designer)}>
                                                    {designer.DesignerName}
                                                </Dropdown.Item>
                                            )
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </Form>
                        {designerSelection != null && Object.keys(inventoryTransaction).includes("Designers") && inventoryTransaction.Designers.length > 1 ?
                            InventoryForParticularDesignerView(inventoryTransaction.Designers.find(x => x.DesignerSysId == designerSelection.DesignerSysId))
                            : <></>}
                    </div> : <></>}
            </div>
            <div className="to-be-hidden2">
            {Object.keys(inventoryTransaction).includes("Designers") ?
                    <div className="tablet-transactions">
                        <div className="tablet-center inventory-form-headline">Die gesamte List von partiellen Inventuren</div>
                        {inventoryTransaction.Designers.map(designer => 
                        <div className="tablet-transactions">
                                {InventoryForParticularDesignerView(designer)}
                        </div>
                    )}
                    <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} message={alertMessage} />
                </div>
                :
                <></>}
            </div>
        </>
    )
}

export default InventoryPartTransactionsView